import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Icon, Message } from 'semantic-ui-react';
import { AppContext } from '../cnr/contexts/AppProvider';
import { _emailSignInStorageItem } from '../cnr/reducers/ValidationReducer';

export const EmailSignInConfirmationSimple = () => {

  const location = useLocation();
  // const auth = getAuth();

  // appContext
  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainAuth } = app_state ?? {}
  const _authDomain = _.get(mainAuth, 'app._options.authDomain')

  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState({});

  useEffect(() => {
    const url = window.location.href;

    const email = window.localStorage.getItem(_emailSignInStorageItem);

    if (isSignInWithEmailLink(mainAuth, url)) {
      if (!email) {
        setResult({ success: false, message: 'Email not found. Please enter your email again.' });
        setLoading(false);
        return;
      }

      signInWithEmailLink(mainAuth, email, url)
        .then(() => {
          console.log('signInWithEmailLink SUCCESS',)
          setResult({ success: true, message: 'Sign-in successful. You can now close this tab.', subMessage: _authDomain });
          window.localStorage.removeItem(_emailSignInStorageItem);
          setLoading(false);
        })
        .catch((error) => {
          setResult({ success: false, message: `Error signing in: ${error.message}` });
          setLoading(false);
        });
    } else {
      setResult({ success: false, message: `Invalid sign-in link` });
      setLoading(false);
    }
  }, [mainAuth, location]);

  let iconName = loading ? 'circle notched' : result.success ? 'thumbs up' : 'thumbs down'
  let iconColor = loading ? 'grey' : result.success ? 'green' : 'red'

  return (
    <Container text style={{ marginTop: '2rem' }}>
      <Message icon>
        <Icon name={iconName} loading={loading} color={iconColor} />
        <Message.Content>
          <Message.Header>Email Link Confirmation</Message.Header>
          <div>{result.message}</div>
          {_authDomain && <div style={{ fontSize: '.7rem' }}>{_authDomain}</div>}
        </Message.Content>
      </Message>
    </Container>
  );
}
